import React from 'react';
import { useOutletContext } from 'react-router-dom';

const PaperForm = () => {
  const { selectedExchange, mode } = useOutletContext();

  return (
    <div className="p-4 bg-gray-900 text-white">
      <h3 className="text-lg font-semibold mb-4">Add {selectedExchange.name} Paper Trading Account</h3>
      <div className="p-4 bg-gray-800 rounded-lg mb-4">
        <p className="text-purple-400 mb-2">
          Paper Trading{' '}
          <span className="text-blue-400">Full Guide</span>
        </p>
      </div>
      <div className="space-y-4">
        <input
          type="text"
          placeholder="Account Label (Spot)"
          defaultValue={`${selectedExchange.name} Paper`}
          className="w-full p-2 bg-gray-700 rounded"
        />
        <p className="text-blue-400 text-sm">Click here to create a {selectedExchange.name} account</p>
        <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
          Save
        </button>
      </div>
    </div>
  );
};

export default PaperForm;